import React from "react";
import { Button } from "@mui/material";

export type InputElement = React.DetailedHTMLProps<
React.InputHTMLAttributes<HTMLInputElement>,
HTMLInputElement
>;

const FileUploadButton = (props: InputElement) => (
  // No htmlFor: an explicit one would override the wrapped input's nested-control
  // association, breaking every caller whose id isn't the hardcoded value.
  <label>
    <input style={{ display: "none" }} type="file" {...props} />
    <Button color="primary" variant="contained" component="span">
        Select Files
    </Button>
  </label>
);

export default FileUploadButton;
